(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    window.toggleCardWishlist = window.toggleCardWishlist || function(btn) {
  var productData = {
    epi: parseInt(btn.getAttribute('data-variant-id')),
    empi: parseInt(btn.getAttribute('data-product-id')),
    du: btn.getAttribute('data-product-url'),
    ru: btn.getAttribute('data-product-url'), 
    iu: btn.getAttribute('data-product-image'),
    pr: parseFloat(btn.getAttribute('data-product-price')),
    dt: btn.getAttribute('data-product-title'),
    ct: "",
    et: 4,
    type: "product-variant"
  };

    function doToggle(swat) {
      var active = btn.classList.contains('is-active');
      if (active) {
        swat.removeFromWishList(productData, function() {
          document.querySelectorAll('.card-wishlist-btn[data-product-id="' + productData.empi + '"]').forEach(function(b) {
            b.classList.remove('is-active');
          });
        }, function() {});
      } else {
        swat.addToWishList(productData, function() {
          document.querySelectorAll('.card-wishlist-btn[data-product-id="' + productData.empi + '"]').forEach(function(b) {
            b.classList.add('is-active');
          });
        }, function() {});
      }
    }

    if (window._swat) {
      doToggle(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(doToggle);
    }
  };

  /* Init: mark hearts as active for products already in wishlist */
  (function initCardWishlistStates() {
    function markActive(swat) {
      if (!swat.fetch) return;
      swat.fetch(function(products) {
        if (!products) return;
        var ids = products.map(function(p) { return p.empi; });
        document.querySelectorAll('.card-wishlist-btn').forEach(function(btn) {
          var pid = parseInt(btn.getAttribute('data-product-id'));
          if (ids.indexOf(pid) !== -1) btn.classList.add('is-active');
        });
      });
    }
    if (window._swat) {
      markActive(window._swat);
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(markActive);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
